/**
 * @module paymentTerms
 * @description A list of paymentTerms
 */

export const paymentTerms = [
	'Net 7',
	'Net 15',
	'Net 30',
	'Net 45',
	'Net 90',
	'Net 120',
] as const;
export type PaymentTerms = (typeof paymentTerms)[number];
